import { combineReducers } from 'redux';

import cadastroConsulta from './cadastro/reducer';
import consultaAtendimentosDeConsulta from './consultaAtendimentosDeConsulta/reducer';

export default combineReducers({
	cadastroConsulta,
	consultaAtendimentosDeConsulta,
});
